export default function ({ app, $config }) {
  if (process.client) {
    const checkUnleashAndInjectOneTrust = () => {
      if (app.$unleash && app.$unleash.isEnabled("showOneTrustBanner")) {
        injectOneTrustScripts();
      }
    };

    const injectOneTrustScripts = () => {
      if (
        document.querySelector("[data-onetrust-loaded]") ||
        document.querySelector("[data-domain-script]") ||
        window.OneTrust ||
        window.OptanonWrapper ||
        window.__ONETRUST_INJECTING__
      ) {
        return;
      }

      window.__ONETRUST_INJECTING__ = true;

      const insertAtHeadStart = (el) => {
        const head = document.head || document.getElementsByTagName("head")[0];
        // Insert at the very beginning, before any existing children
        if (head.firstChild) {
          head.insertBefore(el, head.firstChild);
        } else {
          head.appendChild(el);
        }
      };

      // Create all scripts first
      const autoBlockScript = document.createElement("script");
      autoBlockScript.type = "text/javascript";
      autoBlockScript.src = `${$config.ONETRUST_URL}/consent/${$config.ONETRUST_ID}/OtAutoBlock.js`;
      autoBlockScript.setAttribute("data-onetrust-loaded", "true");
      autoBlockScript.onload = () => {
        window.__ONETRUST_INJECTING__ = false;
      };
      autoBlockScript.onerror = () => {
        window.__ONETRUST_INJECTING__ = false;
      };

      const sdkStubScript = document.createElement("script");
      sdkStubScript.src = `${$config.ONETRUST_URL}/scripttemplates/otSDKStub.js`;
      sdkStubScript.type = "text/javascript";
      sdkStubScript.charset = "UTF-8";
      sdkStubScript.setAttribute("data-domain-script", $config.ONETRUST_ID);

      const wrapperScript = document.createElement("script");
      wrapperScript.type = "text/javascript";
      wrapperScript.textContent = `function OptanonWrapper() {
        // Wait for OneTrust to be fully loaded
        const setupConsentListener = () => {
          if (typeof window?.OneTrust?.OnConsentChanged === 'function') {
            window.OneTrust.OnConsentChanged(function () {
              console.log('OneTrust consent changed, reloading page...');
              window.location.reload();
            });
          } else {
            // Retry after a short delay if OneTrust isn't ready yet
            setTimeout(setupConsentListener, 100);
          }
        };
        
        // Setup the consent listener
        setupConsentListener();
      }`;

      // Insert in reverse so final order at top is: AutoBlock, SDK, Wrapper
      insertAtHeadStart(wrapperScript);
      insertAtHeadStart(sdkStubScript);
      insertAtHeadStart(autoBlockScript);
    };

    if (app.$unleash) {
      checkUnleashAndInjectOneTrust();
    } else {
      const checkInterval = setInterval(() => {
        if (app.$unleash) {
          clearInterval(checkInterval);
          checkUnleashAndInjectOneTrust();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
      }, 10000);
    }
  }
}
